import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SubHeader from '../../components/SubHeader.jsx';
import EmployeeTabMessage from '../../components/employees/EmployeeTabMessage.jsx';
import EmployeeTabPagination from '../../components/employees/EmployeeTabPagination.jsx';
import TasksTable, {
  DESCRIPTION_EXPAND,
  TASK_COLUMNS,
} from '../../components/projects/ChangeImpact/TasksTable.jsx';
import { EMPLOYEE_PROFILE_SHOW_ALL_OWNERS } from '../../constants/employeeProfile.js';
import {
  retrieveEmployeeTasks,
  selectEmployee,
  selectEmployeeTasksState,
} from '../../modules/employees.js';
import EmployeeProfileHeaderContainer from './EmployeeProfileHeaderContainer.jsx';

const mapStateToProps = (state, ownProps) => ({
  employeeLoaded: Boolean(selectEmployee(ownProps.employeeId)(state)),
  listState: selectEmployeeTasksState(state),
});

const mapDispatchToProps = {
  retrieveEmployeeTasks,
};

// Tasks tab of the employee profile: tasks of the change impacts the employee owns
const EmployeeTasksContainer = ({
  employeeId,
  search,
  employeeLoaded,
  listState,
  retrieveEmployeeTasks,
}) => {
  const fetchPage = (page) =>
    retrieveEmployeeTasks(employeeId, { search, page }).catch(() => {});

  useEffect(() => {
    fetchPage(1);
  }, [employeeId, search]);

  const { items, total, page, totalPages, pending, error } = listState;
  const isCurrentEmployee = listState.employeeId === employeeId;

  const renderContent = () => {
    if (error && !pending) {
      return (
        <EmployeeTabMessage>Tasks could not be loaded.</EmployeeTabMessage>
      );
    }
    if (!isCurrentEmployee || (pending && !items.length)) {
      return <EmployeeTabMessage>Loading...</EmployeeTabMessage>;
    }
    if (!items.length) {
      return (
        <EmployeeTabMessage>
          {search
            ? 'No tasks match your search.'
            : 'Change impacts owned by the employee don’t have tasks yet.'}
        </EmployeeTabMessage>
      );
    }
    return (
      <div style={{ opacity: pending ? 0.5 : 1 }}>
        {/* key remounts rows (and their EditorJS instances) per page */}
        <TasksTable
          key={page}
          tasks={items}
          columns={TASK_COLUMNS.EMPLOYEE_PROFILE}
          showAllOwners={EMPLOYEE_PROFILE_SHOW_ALL_OWNERS}
          linkOwnersToEmployee
          reverse={false}
          descriptionExpand={DESCRIPTION_EXPAND.INLINE}
        />
        <EmployeeTabPagination
          page={page}
          totalPages={totalPages}
          onPageChange={fetchPage}
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <EmployeeProfileHeaderContainer employeeId={employeeId} />
      {employeeLoaded ? (
        <section>
          <SubHeader flexJustify small>
            <div className="flex">
              <h2>Tasks</h2>
              <strong className="header-item bordered text-muted">
                Tasks:&nbsp;
                <span className="text-primary">
                  {isCurrentEmployee ? total : 0}
                </span>
              </strong>
            </div>
          </SubHeader>
          {renderContent()}
        </section>
      ) : null}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeTasksContainer);
